export default value => value.trim()
